import { ImgHTMLAttributes, useState, useEffect } from "react";
import { imageFallback, imageFallbackDark } from "../../utils/imageFallback";

export default function OfflineImage({
  src,
  alt = "",
  theme = "light",
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & { theme?: "light" | "dark" }) {
  const [failed, setFailed] = useState<string>();
  useEffect(() => {
    setFailed(undefined);
  }, [src]);
  const fallback = theme === "dark" ? imageFallbackDark : imageFallback;
  return (
    <img
      {...props}
      alt={alt}
      src={failed === src || !src ? fallback : src}
      onError={() => setFailed(src)}
    />
  );
}
